import React from "react";
import PageHeader from "../components/PageHeader";
import ServicesSection from "../components/ServicesSection";
import ContactCTA from "../components/ContactCTA";

const SolutionsPage = () => (
  <>
    <PageHeader title="Our Solutions" breadcrumb="Solutions" />
    <ServicesSection />
    <ContactCTA />
  </>
);

export default SolutionsPage;
